export default __webpack_public_path__ + "static/media/icon-labyrinth.c531f020.svg";